import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '@examflow/ui';
import { useAuth } from '../features/auth/AuthContext';
import {
  canAccessExam,
  hasActiveEntitlement,
  resolveQuizLaunchScope,
} from '@examflow/learning-space';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireEntitlement?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireEntitlement = false,
}) => {
  const { user, entitlements, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
  const launchScope = resolveQuizLaunchScope(location.search);
  const routeExamType =
    new URLSearchParams(location.search).get('examType') || launchScope?.examType || null;

  if (!user) {
    return <Navigate to={`/login?redirect=${redirect}`} state={{ from: location }} replace />;
  }

  if (requireEntitlement) {
    const entitledForRoute = routeExamType
      ? canAccessExam(entitlements, routeExamType)
      : hasActiveEntitlement(entitlements);
    if (!entitledForRoute) {
      return <Navigate to={`/redeem?redirect=${redirect}`} state={{ from: location }} replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
